// file used to track string contants used for the user and things related to the user

// the name of the session token in local storage
export const USER_SESSION_TOKEN = '__session_token';
export const USER_ONBOARDING = '__onboarding';
export const APP_VERSION = '__appVersion';


export const CAMERA_DEVICE_COOKIE = 'cameraId';
export const MIC_DEVICE_COOKIE = 'micId';

export const SCREEN_SHARE_TRACK_NAME = 'screen-video';
export const SCREEN_SHARE_AUDIO_TRACK_NAME = 'screen-audio';
export const CAMERA_TRACK_NAME = 'camera';
export const MIC_TRACK_NAME = 'microphone';

export const STATUS_HISTORY = '__statusHistory';

export const LOCAL_ANALYTICS_DATA = '__LocalAnalyticsData';
